import { 
    apiClient
} from "./APIService";

export const createNewProject = async (userId, projectName) => {
  console.log(userId, projectName);
  const f = await apiClient.post(
    "/newProject",
    {
      userId,
      projectName,
    },
    {
      headers: { "x-access-token": localStorage.getItem("jwt") },
    }
  );
    return f
}

